import { getState } from '~src/state';
import { resizeDimensions } from '~loader/loader-utils';
import $ from 'jquery';
import { px2cm } from '~src/utils/units';
import { gridProvinoIsEnabled } from '~src/utils';

const calculateGridSpace = (format, pdf, minimumBorder) => {
  let maxItemsToFit = Math.floor(pdf / format);
  let amountOfPadding;
  let outerPadding = true;
  let innerPadding = true;

  if (!document.getElementById('outer-provino-grid-padding').checked) {
    outerPadding = false;
  }

  if (!document.getElementById('inner-provino-grid-padding').checked) {
    innerPadding = false;
  }

  if (innerPadding && outerPadding) {
    amountOfPadding = maxItemsToFit + 1;
  }
  if (!outerPadding) {
    amountOfPadding = maxItemsToFit - 1;
  }
  if (!innerPadding) {
    amountOfPadding = 2;
  }

  let totalGridSpace = maxItemsToFit * format;
  let totalEmptySpace = pdf - totalGridSpace;
  let padding = totalEmptySpace / amountOfPadding;

  if (padding < minimumBorder && outerPadding === true) {
    const pdfSize = pdf - minimumBorder * 2;
    maxItemsToFit = Math.floor(pdfSize / format);
    totalGridSpace = maxItemsToFit * format;
    totalEmptySpace = pdf - totalGridSpace;
    padding = totalEmptySpace / amountOfPadding;
  }

  return {
    maxItemsToFit,
    totalGridSpace,
    totalEmptySpace,
    padding,
    outerPadding,
    innerPadding,
  };
};

export const getGridParameters = () => {
  const isGridProvinoEnable = gridProvinoIsEnabled();

  if (isGridProvinoEnable === true) {
    const formatDefault = getState(
      'selected.formatoDefault',
      getState('selected.formato')
    );

    const pdfParameters = $('#navbar-submenu-export-provino-output').select2(
      'data'
    );

    const { width, height } = resizeDimensions(
      formatDefault.width,
      formatDefault.height,
      window.editorLoader.defaultDPI,
      formatDefault.dpi
    );

    let minimumBorder;

    // TODO: allow minimum_border_top and minimum_border_left
    if (typeof formatDefault.minimum_border !== 'undefined') {
      minimumBorder = formatDefault.minimum_border;
    } else {
      minimumBorder = 5;
    }

    const pdfWidth = pdfParameters[0].width;
    const pdfHeight = pdfParameters[0].height;
    const formatHeight = px2cm(height, formatDefault.dpi) * 10;
    const formatWidth = px2cm(width, formatDefault.dpi) * 10;
    const format = { width: formatWidth, height: formatHeight };
    const pdf = {
      width: pdfWidth,
      height: pdfHeight,
      orientation: pdfParameters[0].orientation,
    };

    const rowInfo = calculateGridSpace(formatWidth, pdfWidth, minimumBorder);
    const columnInfo = calculateGridSpace(
      formatHeight,
      pdfHeight,
      minimumBorder
    );
    const ricordiniNumber = rowInfo.maxItemsToFit * columnInfo.maxItemsToFit;
    $('#ricordini-number').text(
      `Numero di ricordini in griglia provino: ${ricordiniNumber}`
    );

    return { rowInfo, columnInfo, format, pdf };
  }
};
